// Payment Page Translations
export const paymentTranslations = {
  en: {
    // Hero Section
    pageTitle: '💳 Payment Methods & Instructions',
    pageSubtitle: 'We offer multiple secure payment options for your convenience. Please carefully follow the instructions for the selected method.',
    whatsappMandatory: 'After payment, sending a screenshot on WhatsApp is',
    mandatory: 'mandatory',
    forVerification: 'for verification.',

    // WhatsApp Contact Banner
    whatsappSupport: '📲 WhatsApp Support',
    clickToChat: 'Click to chat: +92 327 2341839',

    // Payment Process Section
    howPaymentsWork: 'How Payments Work',
    paymentSteps: [
      {
        step: 1,
        title: 'Choose Payment Method',
        description: 'Select your preferred payment method from the options below',
      },
      {
        step: 2,
        title: 'Make Payment',
        description: 'Complete the payment using the provided details',
      },
      {
        step: 3,
        title: 'Screenshot Receipt',
        description: 'Take a clear screenshot of your payment confirmation',
      },
      {
        step: 4,
        title: 'Send on WhatsApp',
        description: 'Send the screenshot to us on WhatsApp for verification',
      },
    ],

    // Payment Methods
    availablePaymentMethods: '🔹 Available Payment Methods',
    instructions: 'Instructions',
    bankDetails: 'Bank Details',
    walletDetails: 'Wallet Details',
    binanceDetails: 'Binance Details',

    paymentMethods: [
      {
        id: 1,
        title: 'Method 1: Revolut to Pakistan',
        subtitle: 'Bank Transfer',
        instructions: [
          'Make payment to the specified account',
          'Please make sure to convert euros into PKR (Pakistani Rupees) and send us the amount in PKR.',
          'Take a clear screenshot or photo of your payment receipt',
          'Press the place order button to upload receipt',
          'Wait for our team to verify your payment',
        ],
        details: [
          { label: 'Bank Name', value: 'HABIB METROPOLITAN BANK' },
          { label: 'IBAN', value: 'PK46MPBL0348567140118696' },
          { label: 'First Name', value: 'AADESH ' },
          { label: 'Last Name', value: 'PARKASH' },
          { label: 'BIC / SWIFT Code', value: 'MPBLPKKA' },
          { label: 'City', value: 'Panoakil' },
          { label: 'Postal Code', value: '65120' },
          { label: 'Address', value: 'Katchari Road, Panoakil' },
          { label: 'Province', value: 'Sindh' },
          { label: 'Email', value: 'lundadesh@gmail.com' },
        ],
      },
      {
        id: 2,
        title: 'Method 2: PayPal (via Xoom)',
        subtitle: 'Mobile Wallet Transfer',
        instructions: [
          'Make payment to the specified account',
          'Take a clear screenshot or photo of your payment receipt',
          'Press the place order button to upload receipt',
          'Wait for our team to verify your payment',
        ],
        details: [
          { label: 'Mobile Wallet', value: 'Easypaisa' },
          { label: 'Mobile Number', value: '+92 319 8435184' },
          { label: 'First Name', value: 'Adeysh' },
          { label: 'Last Name', value: 'Perkash' },
          { label: 'City', value: 'Panoakil' },
          { label: 'Address', value: 'Near Mehran Hospital, Panoakil' },
          { label: 'Postal Code', value: '65120' },
          { label: 'Email', value: 'lundadesh@gmail.com' },
        ],
      },
      {
        id: 3,
        title: 'Method 3: Western Union',
        subtitle: 'Digital Wallet',
        instructions: [
          'Make payment to the specified account',
          'Take a clear screenshot or photo of your payment receipt',
          'Press the place order button to upload receipt',
          'Wait for our team to verify your payment',
        ],
        details: [
          { label: 'Digital Wallet Name', value: 'NayaPay' },
          { label: 'Mobile Number', value: '+92 327 2341839' },
          { label: 'Receiver First Name', value: 'Ghalib' },
          { label: 'Receiver Last Name', value: 'Shahab' },
          { label: 'City', value: 'Panoakil' },
          { label: 'Postal Code', value: '65120' },
          { label: 'Province', value: 'Sindh' },
          { label: 'Address', value: 'Katchari Road, Panoakil' },
          { label: 'Email', value: 'ghalibshahab6@gmail.com' },
        ],
      },
      {
        id: 4,
        title: 'Method 4: Binance',
        subtitle: 'Crypto Transfer',
        instructions: [
          'Make payment to the specified account',
          'Take a clear screenshot or photo of your payment receipt',
          'Press the place order button to upload receipt',
          'Wait for our team to verify your payment',
        ],
        details: [
          { label: 'Binance ID', value: '1174660334' },
          { label: 'Receiver Name', value: 'SubifyHub by Gabriel' },
        ],
      },
    ],

    // Important Notes Section
    importantNotes: '⚠️ Important Notes',
    notes: [
      'Payments without WhatsApp confirmation screenshot may be delayed',
      'Always send the exact amount as agreed',
      'Keep your transaction receipt until confirmation',
      'Activation starts after payment verification',
    ],

    // Security Section
    securePaymentsTitle: 'Secure & Verified Payments',
    securePaymentsDesc: 'All payments are manually verified by our team for your security. We ensure every transaction is processed safely and your subscription is activated promptly after verification.',
    verification24hr: '24hr Verification',
    manualVerification: 'Manual Verification',

    // Support Section
    needHelp: '📞 Need Help?',
    contactSupport: 'Contact our support team on WhatsApp for instant assistance:',
    chatOnWhatsApp: 'Chat on WhatsApp',
    copyToClipboard: 'Copy to clipboard',
  },
  fr: {
    // Hero Section
    pageTitle: '💳 Méthodes de Paiement & Instructions',
    pageSubtitle: 'Nous offrons plusieurs options de paiement sécurisées pour votre commodité. Veuillez suivre attentivement les instructions pour la méthode sélectionnée.',
    whatsappMandatory: 'Après le paiement, l\'envoi d\'une capture d\'écran sur WhatsApp est',
    mandatory: 'obligatoire',
    forVerification: 'pour la vérification.',

    // WhatsApp Contact Banner
    whatsappSupport: '📲 Support WhatsApp',
    clickToChat: 'Cliquez pour discuter : +92 327 2341839',

    // Payment Process Section
    howPaymentsWork: 'Comment Fonctionnent les Paiements',
    paymentSteps: [
      {
        step: 1,
        title: 'Choisir la Méthode de Paiement',
        description: 'Sélectionnez votre méthode de paiement préférée parmi les options ci-dessous',
      },
      {
        step: 2,
        title: 'Effectuer le Paiement',
        description: 'Complétez le paiement en utilisant les détails fournis',
      },
      {
        step: 3,
        title: 'Capture d\'Écran du Reçu',
        description: 'Prenez une capture d\'écran claire de votre confirmation de paiement',
      },
      {
        step: 4,
        title: 'Envoyer sur WhatsApp',
        description: 'Envoyez la capture d\'écran sur WhatsApp pour vérification',
      },
    ],

    // Payment Methods
    availablePaymentMethods: '🔹 Méthodes de Paiement Disponibles',
    instructions: 'Instructions',
    bankDetails: 'Détails Bancaires',
    walletDetails: 'Détails du Portefeuille',
    binanceDetails: 'Détails Binance',

    paymentMethods: [
      {
        id: 1,
        title: 'Méthode 1 : Revolut vers le Pakistan',
        subtitle: 'Virement Bancaire',
        instructions: [
          'Effectuez un paiement vers le compte spécifié',
          'Veuillez vous assurer de convertir les euros en PKR (roupies pakistanaises) et de nous envoyer le montant en PKR.',
          'Prenez une capture d\'écran claire ou une photo de votre reçu de paiement',
          'Appuyez sur le bouton passer la commande pour télécharger le reçu',
          'Attendez que notre équipe vérifie votre paiement',
        ],
        details: [
          { label: 'Nom de la Banque', value: 'HABIB METROPOLITAN BANK' },
          { label: 'IBAN', value: 'PK46MPBL0348567140118696' },
          { label: 'Prénom', value: 'AADESH' },
          { label: 'Nom', value: 'PARKASH' },
          { label: 'Code BIC / SWIFT', value: 'MPBLPKKA' },
          { label: 'Ville', value: 'Panoakil' },
          { label: 'Code Postal', value: '65120' },
          { label: 'Adresse', value: 'Katchari Road, Panoakil' },
          { label: 'Province', value: 'Sindh' },
          { label: 'Email', value: 'lundadesh@gmail.com' },
        ],
      },
      {
        id: 2,
        title: 'Méthode 2 : PayPal (via Xoom)',
        subtitle: 'Transfert Portefeuille Mobile',
        instructions: [
          'Effectuez un paiement vers le compte spécifié',
          'Prenez une capture d\'écran claire ou une photo de votre reçu de paiement',
          'Appuyez sur le bouton passer la commande pour télécharger le reçu',
          'Attendez que notre équipe vérifie votre paiement',
        ],
        details: [
          { label: 'Portefeuille Mobile', value: 'Easypaisa' },
          { label: 'Numéro de Mobile', value: '+92 319 8435184' },
          { label: 'Prénom', value: 'Adesh' },
          { label: 'Nom', value: 'Perkash' },
          { label: 'Ville', value: 'Panoakil' },
          { label: 'Adresse', value: 'Near Mehran Hospital, Panoakil' },
          { label: 'Code Postal', value: '65120' },
          { label: 'Email', value: 'lundadesh@gmail.com' },
        ],
      },
      {
        id: 3,
        title: 'Méthode 3 : Western Union',
        subtitle: 'Portefeuille Numérique',
        instructions: [
          'Effectuez un paiement vers le compte spécifié',
          'Prenez une capture d\'écran claire ou une photo de votre reçu de paiement',
          'Appuyez sur le bouton passer la commande pour télécharger le reçu',
          'Attendez que notre équipe vérifie votre paiement',
        ],
        details: [
          { label: 'Nom du Portefeuille Numérique', value: 'NayaPay' },
          { label: 'Numéro de Mobile', value: '+92 327 2341839' },
          { label: 'Prénom du Destinataire', value: 'Ghalib' },
          { label: 'Nom du Destinataire', value: 'Shahab' },
          { label: 'Ville', value: 'Panoakil' },
          { label: 'Code Postal', value: '65120' },
          { label: 'Province', value: 'Sindh' },
          { label: 'Adresse', value: 'Katchari Road, Panoakil' },
          { label: 'Email', value: 'ghalibshahab6@gmail.com' },
        ],
      },
      {
        id: 4,
        title: 'Méthode 4 : Binance',
        subtitle: 'Transfert Crypto',
        instructions: [
          'Effectuez un paiement vers le compte spécifié',
          'Prenez une capture d\'écran claire ou une photo de votre reçu de paiement',
          'Appuyez sur le bouton passer la commande pour télécharger le reçu',
          'Attendez que notre équipe vérifie votre paiement',
        ],
        details: [
          { label: 'ID Binance', value: '1174660334' },
          { label: 'Nom du Destinataire', value: 'SubifyHub by Gabriel' },
        ],
      },
    ],

    // Important Notes Section
    importantNotes: '⚠️ Notes Importantes',
    notes: [
      'Les paiements sans capture d\'écran de confirmation WhatsApp peuvent être retardés',
      'Envoyez toujours le montant exact convenu',
      'Conservez votre reçu de transaction jusqu\'à la confirmation',
      'L\'activation commence après la vérification du paiement',
    ],

    // Security Section
    securePaymentsTitle: 'Paiements Sécurisés & Vérifiés',
    securePaymentsDesc: 'Tous les paiements sont vérifiés manuellement par notre équipe pour votre sécurité. Nous nous assurons que chaque transaction est traitée en toute sécurité et que votre abonnement est activé rapidement après vérification.',
    verification24hr: 'Vérification 24h',
    manualVerification: 'Vérification Manuelle',

    // Support Section
    needHelp: '📞 Besoin d\'Aide ?',
    contactSupport: 'Contactez notre équipe de support sur WhatsApp pour une assistance immédiate :',
    chatOnWhatsApp: 'Discuter sur WhatsApp',
    copyToClipboard: 'Copier dans le presse-papiers',
  },
};

export const usePaymentTranslations = (language = 'en') => {
  return paymentTranslations[language] || paymentTranslations['en'];
};
